export default {
  BT_HDP: "ハンディキャップ | HDP",
  BT_OU: "オーバー/アンダー | O/U",
  BT_ML: "マネーライン",
  BT_1X2: "1X2",
  BT_1X2HDP: "3ウェイハンディキャップ",
  BT_CS: "正確なスコア",
  BT_OE: "奇数/偶数 | O/E",
  BT_DC: "ダブルチャンス",
  BT_HTFT: "前半/後半",
  BT_FGLG: "初ゴール/最終ゴール",
  BT_TG: "合計ゴール",
  BT_OR: "アウトライト",
  BT_ORZ: "アウトライト",

  BT_ANB: "アウェイノーベット",
  BT_BS: "両チーム/一チーム/どちらもスコアしない",
  BT_CL: "クリーンシート",
  BT_DNB: "ドロー・ノー・ベット",
  BT_HNB: "ホームノーベット",
  BT_TWTN: "勝利を無失点で",

  BT_HDPF: "FT. ハンディキャップ | FT. HDP",
  BT_OUF: "FT. オーバー/アンダー | FT. O/U",
  BT_MLF: "FT. マネーライン",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. 3ウェイハンディキャップ",
  BT_CSF: "FT. 正確なスコア",
  BT_OEF: "FT. 奇数/偶数",
  BT_DCF: "FT. ダブルチャンスe",
  BT_FGLGF: "FT. 初ゴール/最終ゴール",
  BT_TGF: "FT. 合計ゴール",

  BT_HDPH: "1H. ハンディキャップ | 1H. HDP",
  BT_OUH: "1H. オーバー/アンダー | 1H. O/U",
  BT_MLH: "1H. マネーライン",
  BT_1X2H: "1H. 1X2",
  BT_1X2HDPH: "1H. 3ウェイハンディキャップ",
  BT_CSH: "1H. 正確なスコア",
  BT_OEH: "1H. 奇数/偶数",
  BT_DCH: "1H. ダブルチャンス",
  BT_FGLGH: "1H. 初ゴール/最終ゴール",
  BT_TGH: "1H. 合計ゴール",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "ミックスパーライ",
  BT_FT: "FT. ",
  BT_1H: "1H. ",
  BT_2H: "2H. ",

  BT_FG: "初ゴール",
  BT_LG: "最終ゴール",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "ノーゴール",
  BT_HY: "ホームイエス",
  BT_HN: "ホームノー",
  BT_AY: "アウェイイエス",
  BT_AN: "アウェイノー",
  BT_H: "ホーム",
  BT_A: "アウェイ",
  BT_D: "引き分け",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "はい",
  BT_N: "いいえ",

  BT_LIVE: "ライブ",
  BT_HT: "前半",
  BT_DELAYED: "遅延",
  BT_PEN: "ペナルティ",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "両方",
  BT_ONE: "一方",
  
  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",

  BT_ALL: "@:ui.bet_list",

  D_1: "単一番号",
  D_2: "番号 & リバース",
  D_3: "ボックス",
  D_4: "アイボックス",
  D_5: "ボックス最後の3桁",
  D_6: "ボックス最後の2桁",

  D_BIG: "ビッグ",
  D_SMALL: "スモール",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO",

  BT_OEHM: "ホーム 奇数/偶数 | ホーム O/E",
  BT_OEHMH: "前半 ホーム 奇数/偶数 | 前半 ホーム O/E",
  BT_OEAW: "アウェイ 奇数/偶数 | アウェイ O/E",
  BT_OEAWH: "前半 アウェイ 奇数/偶数 | 前半 アウェイ O/E",

  BS_OEHM: "後半 ホーム 奇数/偶数 | 後半 ホーム O/E",
  BS_OEHMH: "前半 ホーム 奇数/偶数 | 前半 ホーム O/E",
  BS_OEAW: "後半 アウェイ 奇数/偶数 | 後半 アウェイ O/E",
  BS_OEAWH: "前半 アウェイ 奇数/偶数 | 前半 アウェイ O/E",

  MB_OVER: "オーバー (4,5,6)",
  MB_UNDER: "アンダー (1,2,3)",
  MB_ODD: "奇数 (1,3,5)",
  MB_EVEN: "偶数 (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "ダブルチャンス + O/U",
  BT_DCOU: "ダブルチャンス + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "前後半 + 奇数/偶数",
  BT_HTFTOE: "前後半 + 奇数/偶数",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "勝利差",
  BT_WM: "勝利差",
  BK_H1: "ホーム 1点差",
  BK_H2: "ホーム 2点差",
  BK_H3Up: "ホーム 3点以上",
  BK_A1: "アウェイ 1点差",
  BK_A2: "アウェイ 2点差",
  BK_A3Up: "アウェイ 3点以上",
  BK_D: "スコア引き分け (0-0除く)",
  BK_NG: "ノーゴール",

  BS_ETG: "正確な合計得点",
  BT_ETG: "正確な合計得点",
  BS_EHTG: "正確なホーム得点数",
  BT_EHTG: "正確なホーム得点数",
  BS_EATG: "正確なアウェイ得点数",
  BT_EATG: "正確なアウェイ得点数",
  BS_ETGH: "前半 正確な合計得点",
  BT_ETGH: "前半 正確な合計得点",
  BS_EHTGH: "前半 正確なホーム得点数",
  BT_EHTGH: "前半 正確なホーム得点数",
  BS_EATGH: "前半 正確なアウェイ得点数",
  BT_EATGH: "前半 正確なアウェイ得点数",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6以上",
  BT_3Up: "3以上",

  BT_CSHTFT: "前後半スコア",
  BS_CSHTFT: "前後半スコア",
  BT_ETGHTFT: "前後半総ゴール",
  BS_ETGHTFT: "前後半総ゴール",
};